import Script from 'next/script';
import { prepareHtml } from '@packages/shared/core/common/utils/prepareHtml';

export function AutofillScript() {
  return (
    <Script
      key="autofill-callback-handler"
      strategy="beforeInteractive"
      id="autofill-callback-handler"
      type="text/javascript"
      dangerouslySetInnerHTML={prepareHtml(
        'window._AutofillCallbackHandler = window._AutofillCallbackHandler || function () {};',
      )}
    />
  );
}
